import React, { Component, } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import { updateMobileOfferForm, updateMobileView, clearMobileOfferForm } from '../../../actions/mobileActions'
import {
    handleRequestShift, handleAcceptProposal, handleRequestOpenShift,
    handleRequestVTO, handleSubmitProposalFromOfferor
} from '../../Utils/handlers'
import { EmployeeDashboardMobileSidePanelStyles } from '../../../../styles/mobileStyles';
import { updateLoading, updateSnackbar, updateEmployeeDashboardData } from '../../../actions';
import { RequestTypes } from '../../../../Enums';
import { ConfirmWithMessageContent } from '../../../components/core';
import ConfirmDialogContent from '../../ConfirmDialogContent';
import { DAILY } from '../constants'
import './commentToManager.scss';

class CommentToManager extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }
    handleSubmitCommentModal = async (message) => {
        const { formData, updateMobileView, clearMobileOfferForm } = this.props;
        switch (formData.type) {
            case RequestTypes.toCover: {
                await handleRequestShift.bind(this)(formData, message);
                break;
            }
            case RequestTypes.shiftSwap: {
                if (formData.raw.isProposedByOfferer && formData.raw.proposals.some(x => x.status === 0)) {
                    const proposal = formData.raw.proposals.find(x => x.status === 0);
                    handleSubmitProposalFromOfferor.bind(this)(formData, proposal, message);
                    break;
                }
                handleAcceptProposal(this, formData.proposalIdSelected, formData, message)
                break;
            }
            case RequestTypes.openShift: {
                await handleRequestOpenShift.bind(this)(formData.raw, message, formData.managerSetting.isPartialShiftEnabled, formData.partialDates);
                break;
            }
            case RequestTypes.voluntaryTimeOff: {
                await handleRequestVTO.bind(this)(formData.offerId, message, formData.partialDates.isPartial, formData.partialDates);
                break;
            }
            default:
                return null;
        }
        updateMobileView(DAILY);
        clearMobileOfferForm();
    }
    render() {
        const { formData, updateMobileView, person } = this.props;

        return (
            <div className="comment-to-manager-container">
                <ConfirmWithMessageContent
                    onCancel={() => updateMobileView(DAILY)}
                    onConfirm={(message) => this.handleSubmitCommentModal(message)}
                >
                    <ConfirmDialogContent
                        request={formData}
                        person={person}
                    />
                </ConfirmWithMessageContent>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        mobileProposalShiftsSelected: state.mobileProposalShiftsSelected,
        dateRanges: state.dateRanges,
        formData: state.mobileOfferShiftForm,
        options: state.httpOptions,
        storeData: state.data, 
        managerSettings: state.managerSettings,
        person: state.person,
        mobileView: state.mobileView,
        managerSettingNames: state.managerSettingNames,
        statusDictionary: state.statusDictionary,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
        updateMobileView: payload => dispatch(updateMobileView(payload)),
        clearMobileOfferForm: () => dispatch(clearMobileOfferForm()),
        updateLoading: payload => dispatch(updateLoading(payload)),
        updateSnackbar: payload => dispatch(updateSnackbar(payload)),
        updateEmployeeDashboardData: payload => dispatch(updateEmployeeDashboardData(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(withStyles(EmployeeDashboardMobileSidePanelStyles)(CommentToManager)));